import Swiper from 'swiper/swiper-bundle';
import 'swiper/swiper-bundle.css';

const swiperSlides = document.getElementsByClassName('swiper-slide');
const breakPoint = 768;
let mySwiper ;
let mySwiperBool ;

window.addEventListener('DOMContentLoaded',()=>{
  // $(function() {
  //   if (window.matchMedia("(max-width: 768px)").matches) {
  //     $('.top-topics__item').removeClass('swiper-no-swiping');
  //     $('.movie-data__item').removeClass('swiper-no-swiping');
  //   } else {
  //       $('.top-topics__item').addClass('swiper-no-swiping');
  //       $('.movie-data__item').addClass('swiper-no-swiping');
  //   };
  //   });
    createSwiperTopic();
    createSwiper();
},false);

window.addEventListener('resize',()=>{
    // $(function() {
    // if (window.matchMedia("(max-width: 768px)").matches) {
    //   $('.top-topics__item').removeClass('swiper-no-swiping');
    //   $('.movie-data__item').removeClass('swiper-no-swiping');
    // } else {
    //     $('.top-topics__item').addClass('swiper-no-swiping');
    //     $('.movie-data__item').addClass('swiper-no-swiping');
    // };
    // });
    createSwiperTopic();
    createSwiper();
},false);

//TOPページ　特集動画
const createSwiperTopic = () =>{
  mySwiper = new Swiper('.swiper-topic', {
    // preloadImages: false,
    // //前後の画像を先に読み込んでおく
    // lazy: {
    //   loadPrevNext: true,
    // },
    // preventClicks: false,
    // preventClicksPropagation: false,
    freeMode:true,
    centeredSlides : false,
    slidesPerView:2.2,
    spaceBetween:  12,
    // shortSwipes:false,
    passiveListeners: false,
    // loopさせるとswiper-button-prevが無効にできないためfalse
    // loop: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
        569: {
        slidesPerView: 2,
        spaceBetween:  12,
        },
        768: {
        slidesPerView: 2.1,
        spaceBetween:  16,
        },
        1366: {
        slidesPerView: 2.2,
        spaceBetween:  32,
        },
        1536: {
        slidesPerView: 3.4,
        spaceBetween:  40,
        },
    },
    });
}
//　動画一覧
const createSwiper = () =>{
    mySwiper = new Swiper('.swiper', {
    // preloadImages: false, 
    // lazy: {
    //   loadPrevNext: true,
    // },
    // preventClicks: false,
    // preventClicksPropagation: false,
    freeMode:true,
    centeredSlides : false,
    slidesPerView:2.2,
    spaceBetween:  12,
    // shortSwipes:false,
    passiveListeners: false,
    // loop: true,
    // touchAngle: 30,
    navigation: {
        nextEl: '.swiper-button-next-movie',
        prevEl: '.swiper-button-prev-movie',
    },
    breakpoints: {
        768: {
            slidesPerView: 2.5,
            spaceBetween:  12,
        },
        1366: {
            slidesPerView: 3.7,
            spaceBetween:  32,

        },
        1536: {
            slidesPerView: 4.2,
            spaceBetween:  40,
        },
    },
});
}

//kv
var mySwiperKv = new Swiper('.swiper-kv', {
    loop: true,
    speed: 1500,
    loopAdditionalSlides: 1,

        autoplay: {
            delay: 3000,
            disableOnInteraction: false,
        },
    });

//新着スポットバイト
var mySwipernewbyte = new Swiper('.slide', {
    loop: true,
    speed: 1000,
    loopAdditionalSlides: 1,

    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
    pagination: {
        el: ".swiper-pagination",
        clickable: true,
    },
    centeredSlides: true,
    spaceBetween: 20,
    slidesPerView: 1.2,
    breakpoints: {
        500: {//500以上の表示
            slidesPerView: 'auto',
            spaceBetween: 30,
        }
    }
    
});

//求人詳細 detail
var mySwiperKv = new Swiper('.swiper-detail', {
    loop: true,
    speed: 1000,
    slidesPerView:1.2,
    spaceBetween:10,
    centeredSlides: true,
    
    breakpoints: {
        767: {//767以上の表示
            slidesPerView: 1.5,
            spaceBetween: 10,
        }
    },
    // loopAdditionalSlides: 1,

    // autoplay: {
    //     delay: 3000,
    //     disableOnInteraction: false,
    // },
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
    }
});


